import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { TipoDeMensajeSwal } from '../models/enums/tipo-de-mensaje-swal';

@Injectable({
  providedIn: 'root'
})
export class SweetAlertService {

  constructor() { }

  mensajeConfirmacion(tipo: TipoDeMensajeSwal, titulo: string, texto: string, colorBotonConfirmar?: string, colorBotonCancelar?: string) : Promise<any> {
    return Swal.fire({
      title: titulo,
      text: texto,
      type: tipo,
      showCancelButton: true,
      confirmButtonColor: (colorBotonConfirmar) ? colorBotonConfirmar : '#3085d6',
      cancelButtonColor: (colorBotonCancelar) ? colorBotonCancelar : '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
  }

  mensajeConfirmacionHtml(tipo: TipoDeMensajeSwal, titulo: string, texto: string, colorBotonConfirmar?: string) : Promise<any> {
    return Swal.fire({
      title: titulo,
      html: texto,
      type: tipo,
      showCancelButton: false,
      confirmButtonColor: (colorBotonConfirmar) ? colorBotonConfirmar : '#3085d6',
      confirmButtonText: 'Aceptar'
    });
  }

  mostrar(tipo: any, titulo: string, cuerpo: string) {
    Swal.fire({
      type: tipo,
      title: titulo,
      text: cuerpo,
    })
  }

  mostrarMensajeHtml(tipo: any, titulo: string, cuerpo: string) {
    Swal.fire({
      type: tipo,
      title: titulo,
      html: cuerpo,
    })
  }
}
